import { Entity } from "../helpers/Entity"
import { INTEGRATION_KEY } from "../integration/Constants"

export type AccountAttributesDto = {
    companyName: string
    currency: string
    integrationKey: string
}

export type AccountDto = {
    id: string
    type: string
    attributes: AccountAttributesDto
}

export default class Account implements Entity {
    private dto: AccountDto

    constructor(dto: AccountDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return this.dto.id != "" && this.dto.type == "accounts"
    }

    getId(): string {
        return this.dto.id
    }

    getDto(): AccountDto {
        return this.dto
    }

    getCompanyName(): string {
        return this.dto.attributes.companyName
    }

    getCurrency(): string {
        return this.dto.attributes.currency
    }

    hasUSDCurrency(): boolean {
        return this.getCurrency() == "USD"
    }

    getIntegrationKey(): string {
        return this.dto.attributes.integrationKey
    }

    hasShopifyIntegrationKey(): boolean {
        return [INTEGRATION_KEY.SHOPIFY, INTEGRATION_KEY.SHOPIFY_EXPERT_APP].includes(this.getIntegrationKey())
    }
}




// WEBPACK FOOTER //
// ./src/state/account/account.ts